module.exports = __webpack_public_path__ + "static/img/cygn6.1736675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn6.png
// module id = 315
// module chunks = 0